import React from 'react';

import { isNil } from 'es-toolkit';

import { useVerificationRequestsReportListQuery, VerificationRequestWhere } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { gql } from 'src/utils/gql';

import { useVerificationRequestsSearchFilter } from './useVerificationRequestsSearchFilter';

export const useVerificationRequestsReportList = (
  filter?: VerificationRequestWhere,
  skip?: boolean,
) => {
  const prepareSearchFilter = useVerificationRequestsSearchFilter();
  const searchQueryVariables = useSearchQueryVariables(prepareSearchFilter);
  const { sortQueryVariable, paginationQueryVariables } = useFilterStorage();

  const queryVariables = React.useMemo(
    () => ({
      filter: !isNil(filter) ? gql.wrapToAND([filter, searchQueryVariables]) : searchQueryVariables,
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    }),
    [filter, paginationQueryVariables, searchQueryVariables, sortQueryVariable],
  );

  const { data, loading } = useVerificationRequestsReportListQuery({
    variables: queryVariables,
    skip,
    fetchPolicy: 'cache-and-network',
  });

  return {
    verificationRequestsCount: data?.verificationRequestCount || 0,
    verificationRequests: data?.getVerificationRequestsListForReport ?? [],
    loading,
  };
};
